import { render } from "./ColorBox.vue?vue&type=template&id=6ac63306&scoped=true"
import script from "./ColorBox.vue?vue&type=script&lang=js"
export * from "./ColorBox.vue?vue&type=script&lang=js"

import "./ColorBox.vue?vue&type=style&index=0&id=6ac63306&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac63306"]])

export default __exports__